//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { KPI, cachedSetEconomicsKpiDataCommunity } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

export const EconomicsKpiCommunityResolver = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;
  const pathSegment = location.pathname.split('/')[1];

  async function init() {

    if (!pathSegment.includes('community')) {
      return;
    }

    const COMMUNITY_ID = params?.id;

    if (!COMMUNITY_ID) {
      return;
    }

    if (metadata?.entities.length === 0) return;

    dispatch(
      KPI.ResetNamedKpiFields(['EconomicsSite', 'EconomicsMember', 'memberRanking'] as any)
    );

    // Token auto-injected by httpService interceptor
    dispatch(
      cachedSetEconomicsKpiDataCommunity({
        COMMUNITY_ID,
        selectedDate,
        selectedTimeSet,
        metadata,
      }) as any
    );
  }

  useEffect(() => {
    init();
  }, [params.id, selectedDate, pathSegment, metadata?.entities]);

  return <></>;
};
